import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';


@Component({
  selector: 'app-confirm',
  imports: [CommonModule, DialogModule],
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
})
export class ConfirmComponent {

  @Input() confirm?: () => void;
  @Input() cancel: string = 'Cancel';
  @Input() delete: string = 'Delete';
  @Input() paragraph: string = 'This action cannot be undone.';



  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() message: string = 'Are you sure?';


  @Output() confirmed = new EventEmitter<void>();

  onClick(): void {
   
    this.visible = false;
    this.visibleChange.emit(false);

  
    if (this.confirm) {
      try {
        this.confirm();
      } catch (e) {
        console.error(e);
      }
    }
    this.confirmed.emit();
  }

  onHide() {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
